import { Locale } from './types';

// Locale-aware route definitions
export const routes = {
  es: {
    home: '/es',
    coaching: '/es/coaching-ejecutivo',
    about: '/es/sobre-andres',
    interviews: '/es/entrevistas-y-medios',
    talks: '/es/charlas-y-conferencias',
    ecosystem: '/es/ecosistema-greenin',
    blog: '/es/blog',
    blogPost: '/es/blog/:slug',
    books: '/es/libros-y-publicaciones',
    resources: '/es/recursos',
    contact: '/es/contacto',
    checkout: '/es/checkout',
    privacy: '/es/politica-de-privacidad',
    terms: '/es/terminos-de-servicio',
    payments: '/es/politica-de-pagos',
    cookies: '/es/politica-de-cookies',
    accessibility: '/es/accesibilidad',
  },
  en: {
    home: '/en',
    coaching: '/en/executive-coaching',
    about: '/en/about',
    interviews: '/en/interviews-media',
    talks: '/en/speaking',
    ecosystem: '/en/greenin-ecosystem',
    blog: '/en/blog',
    blogPost: '/en/blog/:slug',
    books: '/en/books-publications',
    resources: '/en/resources',
    contact: '/en/contact',
    checkout: '/en/checkout',
    privacy: '/en/privacy-policy',
    terms: '/en/terms-of-service',
    payments: '/en/payment-policy',
    cookies: '/en/cookies-policy',
    accessibility: '/en/accessibility',
  },
} as const;

export type RouteKey = keyof typeof routes.es;

export function getRoutes(locale: Locale) {
  return routes[locale];
}

export function getAlternateUrl(currentPath: string, targetLocale: Locale): string {
  const sourceLocale: Locale = currentPath.startsWith('/en') ? 'en' : 'es';
  const sourceRoutes = routes[sourceLocale];
  const targetRoutes = routes[targetLocale];

  for (const key of Object.keys(sourceRoutes) as RouteKey[]) {
    const sourceRoute = sourceRoutes[key];
    // Handle dynamic routes (blog posts)
    if (key === 'blogPost') {
      const pattern = sourceRoute.replace(':slug', '([^/]+)');
      const match = currentPath.match(new RegExp(`^${pattern}$`));
      if (match) {
        return targetRoutes[key].replace(':slug', match[1]);
      }
      continue;
    }
    if (currentPath === sourceRoute) {
      return targetRoutes[key];
    }
  }

  // Default: swap locale prefix
  if (currentPath.startsWith(`/${sourceLocale}`)) {
    return `/${targetLocale}${currentPath.slice(3)}`;
  }
  return `/${targetLocale}`;
}

export function getLocaleFromPath(path: string): Locale {
  if (path.startsWith('/en')) return 'en';
  return 'es';
}

// Breadcrumb generation
export interface Breadcrumb {
  label: string;
  href: string;
}

export function getBreadcrumbs(path: string, locale: Locale, pageLabel: string): Breadcrumb[] {
  const r = routes[locale];
  const crumbs: Breadcrumb[] = [
    { label: locale === 'es' ? 'Inicio' : 'Home', href: r.home },
  ];

  if (path !== r.home) {
    crumbs.push({ label: pageLabel, href: path });
  }

  return crumbs;
}
